import { backofficeFilterPreferencesConfig } from '@/backoffice/features/filter-preferences/config/backoffice-filter-preferences-config';
import { backofficeGroupsConfig } from '@/backoffice/features/groups/config/backoffice-groups-config';
import { backofficeRbacConfig } from '@/backoffice/features/rbac/config/backoffice-rbac-config';
import { TAppConfig } from '@/shared/features/app-config/context/app-config-context.types';

export const backofficeAppConfig: TAppConfig = {
  rbac: backofficeRbacConfig,
  groups: backofficeGroupsConfig,
  filterPreferences: backofficeFilterPreferencesConfig,
};
